// extracted by mini-css-extract-plugin
export default {"advs":"advs___ejirGnX","advsTitle":"advsTitle___ejirGnX","titleBig":"titleBig___ejirGnX"};